import 'dayjs/locale/ru';
import { localStorageColorSchemeManager, MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import { AuthProvider } from '@/stores/authContext';
import { router } from '@/routes';
import { theme } from '@/styles/theme';

const colorSchemeManager = localStorageColorSchemeManager({ key: 'data1861-color-scheme' });

// Server-state слой. Повторы делегированы транспорту (api/httpClient) — поэтому retry:false здесь,
// чтобы не дублировать политику повторов.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false, staleTime: 30_000 },
    mutations: { retry: false },
  },
});

export default function App() {
  return (
    <MantineProvider
      theme={theme}
      defaultColorScheme="light"
      colorSchemeManager={colorSchemeManager}
    >
      {/* Внутри MantineProvider: экран ошибки собран на компонентах Mantine. */}
      <ErrorBoundary>
      <DatesProvider settings={{ locale: 'ru', firstDayOfWeek: 1, weekendDays: [0, 6] }}>
        <QueryClientProvider client={queryClient}>
          <Notifications position="top-right" />
          <ModalsProvider>
            <AuthProvider>
              <RouterProvider router={router} future={{ v7_startTransition: true }} />
            </AuthProvider>
          </ModalsProvider>
        </QueryClientProvider>
      </DatesProvider>
      </ErrorBoundary>
    </MantineProvider>
  );
}
